module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    staticClass: "quickInput",
    attrs: {
      "type": "text"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "ElementSummary"
  }, [_c('tr', [_c('td', [_vm._v("\n            " + _vm._s(this.elements.length) + " items\n        ")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "quick-input",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.elements), function(element) {
    return _c('tr', {
      key: element.key,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.log(element)
        }
      }
    }, [_c('td', [_c('span', {
      attrs: {
        "title": element.name
      }
    }, [_vm._v(_vm._s(element.title || element.key))])]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "truncate"
    }, [_vm._v(_vm._s(element.value))])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3664b6e9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/ElementSummary.vue
// module id = 2503
// module chunks = 1